import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { ExpertWorkspaceService } from '@libs/shared/api';
import { injectCoreFeature } from '@sprint-expert/app/core/state/core.service';
import { hasExpertWorkspaceActiveSubscription } from '@sprint-expert/app/utils/functions/expert-workspace.utils';
import { EMPTY, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ExpertWorkspaceTeamPlanGuard implements CanActivate {
  private readonly core = injectCoreFeature();
  private readonly router = inject(Router);
  private readonly expertWorkspaceService = inject(ExpertWorkspaceService);

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const expertWorkspaceId = route.params['expertWorkspaceId'];
    if (!expertWorkspaceId) {
      console.error('expertWorkspaceId is null');
      this.router.navigateByUrl('/').then();
    }

    return this.expertWorkspaceService
      .fetchExpertWorkspaceById(expertWorkspaceId)
      .pipe(
        map(expertWorkspace => {
          this.core.setExpertWorkspace(expertWorkspace);
          if (!hasExpertWorkspaceActiveSubscription(expertWorkspace)) {
            this.router.navigateByUrl('/').then();
            return false;
          }
          if (expertWorkspace.activeSubscriptionPlanType === 'Personal') {
            this.router.navigateByUrl('/').then();
            return false;
          }
          const currentExpertWorkspaceExpert =
            expertWorkspace.workspaceExperts.find(
              workspaceExpert =>
                workspaceExpert.expert.id === this.core.currentUserId$$()
            );
          if (currentExpertWorkspaceExpert.role === 'Member') {
            this.router.navigateByUrl('/').then();
            return false;
          }
          return true;
        }),
        catchError(() => {
          this.router.navigateByUrl('/500').then();
          return EMPTY;
        })
      );
  }
}
